<template>
    <div class="table-responsive">
        <table class="table-bordered table">
            <tbody>
                <template v-if="SWITCH_FIELD_TAB_1(dataObject, isPreview)['格納場所']">
                    <tr>
                        <th class="bg-color7 font-weight-bold" colspan="2">
                            <div class="d-flex flex-wrap align-items-center justify-content-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    v-model="SWITCH_FIELD_TAB_1(dataObject)['格納場所']"
                                    switch
                                    @change="
                                        toggleCommonSwitch($event, {
                                            storage_site: dataObject.storage_site,
                                            file_name: dataObject.file_name,
                                            free_block_storage_location: dataObject.free_block_storage_location
                                        })
                                    "
                                />
                                格納場所
                            </div>
                        </th>
                    </tr>
                    <tr>
                        <td style="width: 200px">格納場所</td>
                        <td>
                            <InputText
                                :model.sync="dataObject.storage_site.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['格納場所']"
                                :config="inputConfig.storage_site"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style="width: 200px">ファイル名</td>
                        <td>
                            <InputText
                                :model.sync="dataObject.file_name.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['格納場所']"
                                :config="inputConfig.file_name"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style="vertical-align: top">
                            <b-form-input
                                v-model="dataObject.free_block_storage_location.title"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['格納場所']"
                                :class="`${isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['格納場所'] ? 'disabled_cursor' : ''} `"
                            ></b-form-input>
                        </td>
                        <td>
                            <div
                                v-if="isNotCheckBoxPartner || isDisabled"
                                class="box--text__disabled"
                                v-html="dataObject.free_block_storage_location.data"
                            ></div>
                            <Editor
                                v-else
                                :id="`editor-格納場所-${idTab}`"
                                :model.sync="dataObject.free_block_storage_location.data"
                                :configInit="{
                                    disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['格納場所'],
                                    is_autoresize_on: true
                                }"
                            />
                        </td>
                    </tr>
                </template>
                <tr v-if="SWITCH_FIELD_TAB_1(dataObject, isPreview)['格納場所']">
                    <th colspan="2" class="text-danger">※格納場所記載の場合以下削除</th>
                </tr>
                <template v-if="SWITCH_FIELD_TAB_1(dataObject, isPreview)['WEB管理画面']">
                    <tr>
                        <td colspan="2" class="text-center bg-color8 font-weight-bold">
                            <div class="d-flex flex-wrap align-items-center justify-content-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    v-model="SWITCH_FIELD_TAB_1(dataObject)['WEB管理画面']"
                                    switch
                                    @change="
                                        toggleCommonSwitch($event, {
                                            web_management_screen: dataObject.web_management_screen,
                                            free_block_web_management: dataObject.free_block_web_management
                                        })
                                    "
                                />
                                WEB管理画面
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <div
                                :class="`d-flex box--text__disabled ${isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['WEB管理画面'] ? 'disabled_input' : ''}`"
                                :style="{
                                    'background-color':
                                        isNotCheckBoxPartner || isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['WEB管理画面'] ? '' : '#ffffff',
                                    gap: '0.5rem'
                                }"
                            >
                                <div class="form-group" style="max-width: 50%; flex: 1">
                                    <div class="text-center text-nowrap mb-1" style="min-width: 100%; font-weight: 600">フォームのURL</div>
                                    <div v-for="itemForm in detailBeginForDocument.forms" :key="`link-${itemForm.id}`" class="pl-2">
                                        <a
                                            v-if="itemForm.status === STATUS_FORM_LIST.PUBLISHING && !itemForm.is_first_create"
                                            :href="getFormUrl(itemForm)"
                                            target="_blank"
                                            :class="`d-block element__span ${isPreview ? 'text--not-allowed' : ''}`"
                                            >{{ getFormUrl(itemForm) }}</a
                                        >
                                        <span v-else class="element__span">{{ getFormUrl(itemForm) }}</span>
                                    </div>
                                    <div v-if="listFormUrlCustom?.length > 0" class="mt-3">
                                        <div
                                            v-for="(urlCustom, idx) in listFormUrlCustom"
                                            :key="`link-custom-${idx}`"
                                            class="mb-2 d-flex align-items-center pl-2 left-custom-row"
                                            :style="{ minHeight: '38px', height: textareaHeights[idx] ? `${textareaHeights[idx]}px` : 'auto' }"
                                        >
                                            <a
                                                :href="urlCustom"
                                                target="_blank"
                                                :class="`d-block element__span ${isPreview ? 'text--not-allowed' : ''}`"
                                                style="word-break: break-all"
                                                >{{ urlCustom }}</a
                                            >
                                        </div>
                                    </div>
                                </div>
                                <div style="border-right: 1px solid #ccc"></div>
                                <div class="form-group" style="max-width: 50%; flex: 1">
                                    <div class="text-center text-nowrap mb-1" style="min-width: 100%; font-weight: 600">管理画面のURL</div>
                                    <div v-for="itemForm in detailBeginForDocument.forms" :key="`manager-form-${itemForm.id}`" class="pl-2">
                                        <a
                                            :href="`${localtionForm}/manager-form/analytics?id=${itemForm.id}`"
                                            target="_blank"
                                            :class="`d-block element__span ${isPreview ? 'text--not-allowed' : ''}`"
                                            >{{ `${localtionForm}/manager-form/analytics?id=${itemForm.id}` }}</a
                                        >
                                    </div>
                                    <div v-if="listFormUrlCustom?.length > 0" class="mt-3">
                                        <div
                                            v-for="(urlCustom, idx) in listFormUrlCustom"
                                            :key="`analytic-custom-${idx}`"
                                            class="mb-2 d-flex align-items-center pl-2 right-custom-row"
                                            style="min-height: 38px"
                                        >
                                            <div
                                                v-if="isNotCheckBoxPartner || isDisabled"
                                                v-html="
                                                    convertHtmlLinks(
                                                        renderLineBreaks(dataObject.web_management_screen.analytic_form_url_out[idx].data)
                                                    )
                                                "
                                                :class="`element__span ${isPreview ? 'text--not-allowed' : ''}`"
                                            />
                                            <TextareaComponent
                                                v-else
                                                :id="`tab1-textarea-3-analytic-${idx}`"
                                                :model.sync="dataObject.web_management_screen.analytic_form_url_out[idx].data"
                                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['WEB管理画面']"
                                                :isPreview="isPreview"
                                                :config="inputConfig.web_management_screen.analytic_form_url_out.$each[idx].data"
                                                rows="1"
                                                style="width: 100%"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="vertical-align: top">
                            <b-form-input
                                v-model="dataObject.free_block_web_management.title"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['WEB管理画面']"
                                :class="`${isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['WEB管理画面'] ? 'disabled_cursor' : ''} `"
                            ></b-form-input>
                        </td>
                        <td>
                            <div
                                v-if="isNotCheckBoxPartner || isDisabled"
                                class="box--text__disabled"
                                v-html="dataObject.free_block_web_management.data"
                            ></div>
                            <Editor
                                v-else
                                :id="`editor-WEB管理画面-${idTab}`"
                                :model.sync="dataObject.free_block_web_management.data"
                                :configInit="{
                                    disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['WEB管理画面'],
                                    is_autoresize_on: true
                                }"
                            />
                        </td>
                    </tr>
                </template>
                <template v-if="isShowSNSAccount">
                    <tr>
                        <td colspan="2" class="text-center bg-color8 font-weight-bold">
                            <div class="d-flex flex-wrap align-items-center justify-content-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    v-model="SWITCH_FIELD_TAB_1(dataObject)['SNSアカウント']"
                                    switch
                                    @change="
                                        toggleCommonSwitch($event, {
                                            social_media_account: dataObject.social_media_account,
                                            free_block_social_media: dataObject.free_block_social_media
                                        })
                                    "
                                />
                                SNSアカウント
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <TextareaComponent
                                id="tab1-textarea-1"
                                :model.sync="dataObject.social_media_account.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['SNSアカウント']"
                                :isPreview="isPreview"
                                :config="inputConfig.social_media_account"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style="vertical-align: top">
                            <b-form-input
                                v-model="dataObject.free_block_social_media.title"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['SNSアカウント']"
                                :class="`${isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['SNSアカウント'] ? 'disabled_cursor' : ''} `"
                            ></b-form-input>
                        </td>
                        <td>
                            <div
                                v-if="isNotCheckBoxPartner || isDisabled"
                                class="box--text__disabled"
                                v-html="dataObject.free_block_social_media.data"
                            ></div>
                            <Editor
                                v-else
                                :id="`editor-SNSアカウント-${idTab}`"
                                :model.sync="dataObject.free_block_social_media.data"
                                :configInit="{
                                    disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['SNSアカウント'],
                                    is_autoresize_on: true
                                }"
                            />
                        </td>
                    </tr>
                </template>
                <template v-if="isShowLTarget">
                    <tr>
                        <td colspan="2" class="text-center bg-color8 font-weight-bold">
                            <div class="d-flex flex-wrap align-items-center justify-content-center">
                                <b-form-checkbox
                                    v-if="!isPreview && !isRolePartner"
                                    v-model="SWITCH_FIELD_TAB_1(dataObject)['Lターゲット']"
                                    switch
                                    @change="
                                        toggleCommonSwitch($event, {
                                            cr_supporter: dataObject.cr_supporter,
                                            free_block_cr_supporter: dataObject.free_block_cr_supporter
                                        })
                                    "
                                />
                                Lターゲット
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2">
                            <TextareaComponent
                                id="tab1-textarea-2"
                                :model.sync="dataObject.cr_supporter.data"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['Lターゲット']"
                                :isPreview="isPreview"
                                :config="inputConfig.cr_supporter"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style="vertical-align: top">
                            <b-form-input
                                v-model="dataObject.free_block_cr_supporter.title"
                                :disabled="isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['Lターゲット']"
                                :class="`${isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['Lターゲット'] ? 'disabled_cursor' : ''} `"
                            ></b-form-input>
                        </td>
                        <td>
                            <div
                                v-if="isNotCheckBoxPartner || isDisabled"
                                class="box--text__disabled"
                                v-html="dataObject.free_block_cr_supporter.data"
                            ></div>
                            <Editor
                                v-else
                                :id="`editor-Lターゲット-${idTab}`"
                                :model.sync="dataObject.free_block_cr_supporter.data"
                                :configInit="{
                                    disabled: forceEnableEditors ? false : isDisabled || !SWITCH_FIELD_TAB_1(dataObject)['Lターゲット'],
                                    is_autoresize_on: true
                                }"
                            />
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import { InputText } from '@/components/Input';
import { STATUS_FORM_LIST } from '@/views/pages/phase2/manager-form/constants';
import { CONFIG_INPUT_TAB_1, SWITCH_FIELD_TAB_1 } from '@/views/pages/require/const-field-tab';
import { toggleCommonSwitch, isRolePartner, checkPlatFomTab, getFormUrlCustom } from '@/views/pages/require/handlers';
import { expandEachConfig } from '@/utils/validate_v2.js';
import { convertHtmlLinks, renderLineBreaks } from '@/utils/format';

import TextareaComponent from '@/components/Textarea/main.vue';
import Editor from '@/components/Editor/main.vue';
import editorDelayMixin from '@/mixins/editorDelayMixin';

export default {
    name: 'Tab1Require',
    mixins: [editorDelayMixin],
    components: {
        InputText,
        TextareaComponent,
        Editor
    },
    props: {
        idTab: {
            type: [String, Number],
            default: ''
        },
        dataObject: {
            type: Object,
            required: true,
            default: () => ({})
        },
        detailBeginForDocument: {
            type: Object,
            default: () => ({})
        },
        isDisabled: {
            type: Boolean,
            default: () => false
        },
        isPreview: {
            type: Boolean,
            default: () => false
        },
        isNotCheckBoxPartner: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            STATUS_FORM_LIST,
            domain: process.env.VUE_APP_DOMAIN_LP,
            localtionForm: window.location.origin,
            inputConfig: CONFIG_INPUT_TAB_1(),
            isRolePartner: isRolePartner(),
            listFormUrlCustom: [],
            textareaHeights: {},
            resizeObservers: []
        };
    },

    computed: {
        hasFormsOrCustomUrls() {
            const forms = this.detailBeginForDocument?.forms;
            const customUrls = this.listFormUrlCustom;
            return (Array.isArray(forms) && forms.length > 0) || (Array.isArray(customUrls) && customUrls.length > 0);
        },
        isShowSNSAccount() {
            if (!SWITCH_FIELD_TAB_1(this.dataObject, this.isPreview)['SNSアカウント']) {
                return false;
            }
            if (this.hasFormsOrCustomUrls) {
                return true;
            }
            return this.checkPlatFomTab(['Instagram', 'TikTok', 'X']);
        },
        isShowLTarget() {
            if (!SWITCH_FIELD_TAB_1(this.dataObject, this.isPreview)['Lターゲット']) {
                return false;
            }
            if (this.hasFormsOrCustomUrls) {
                return true;
            }
            return this.checkPlatFomTab(['LINE']);
        }
    },

    watch: {
        isPreview() {
            this.initTextareaObservers();
        },
        isDisabled() {
            this.initTextareaObservers();
        },
        listFormUrlCustom() {
            this.initTextareaObservers();
        }
    },

    mounted() {
        this.initTextareaObservers();
    },

    beforeDestroy() {
        if (this.resizeObservers && this.resizeObservers.length > 0) {
            this.resizeObservers.forEach((obs) => obs.disconnect());
        }
    },

    methods: {
        getFormUrl(item) {
            const domainForm = item?.domain || process.env.VUE_APP_DOMAIN_FORM;
            return `https://${domainForm}/form/${item.url_public}`;
        },
        toggleCommonSwitch,
        SWITCH_FIELD_TAB_1,
        expandEachConfig,
        convertHtmlLinks,
        renderLineBreaks,

        checkPlatFomTab(label) {
            return checkPlatFomTab(this.detailBeginForDocument.categories, label);
        },

        initTextareaObservers() {
            if (this.resizeObservers && this.resizeObservers.length > 0) {
                this.resizeObservers.forEach((obs) => obs.disconnect());
            }
            this.resizeObservers = [];

            this.$nextTick(() => {
                const rightRows = this.$el.querySelectorAll('.right-custom-row');
                rightRows.forEach((el, idx) => {
                    const observer = new ResizeObserver(() => {
                        const height = el.offsetHeight;
                        this.$set(this.textareaHeights, idx, height);
                    });
                    observer.observe(el);
                    this.resizeObservers.push(observer);
                });
            });
        }
    },
    created() {
        const formUrlCustom = getFormUrlCustom(this.detailBeginForDocument.categories);
        this.listFormUrlCustom = formUrlCustom || [];
        if (formUrlCustom) {
            expandEachConfig(
                { analytic_form_url_out: formUrlCustom },
                { analytic_form_url_out: this.inputConfig.web_management_screen.analytic_form_url_out }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
td,
th {
    vertical-align: middle;
}

a.element__span,
::v-deep .element__span a {
    color: #5664d2 !important;
    &:hover {
        color: darken(#5664d2, 10%) !important;
    }
}
</style>
